import script from "./CoursePage.vue?vue&type=script&setup=true&lang=js"
export * from "./CoursePage.vue?vue&type=script&setup=true&lang=js"

import "./CoursePage.vue?vue&type=style&index=0&id=55a2dc40&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55a2dc40"]])

export default __exports__